import * as TYPES from './action-types';

export const setStep = data => ({
  type: TYPES.SET_STEP,
  data,
});
